const Utilities = {
	initMapIdle: ( tm ) => {
		tm.isIdle = false;
		tm.map.addListener( 'idle', function () {
			tm.isIdle = true;
		} );
		tm.map.addListener( 'bounds_changed', function () {
			tm.isIdle = false;
		} );
	},

	initMapZoom: ( tm, features ) => {
		// Update zoom when window is resized
		window.addEventListener( 'resize', () => Utilities.throttle( Utilities.zoomToBounds( tm, tm.currentBounds ), 50 ) );

		// Update zoom controls visibility when window is resized
		window.addEventListener( 'resize', () => Utilities.throttle( Utilities.shouldDisplayZoomControls( tm ), 50 ) );

		// On load, map can either zoom out to show all agencies or zoom in on a route or stop
		if ( Utilities.isZoomedOutOnLoad() ) {
			// set the default zoom to show all agencies
			let bounds = new google.maps.LatLngBounds();
			features.forEach( ( feature ) => {
				bounds.union( feature.getProperty( 'bounds' ) );
			} );
			Utilities.zoomToBounds( tm, bounds );
		}
	},

	// zoomed out by default, unless on the bus routes tab to zoom into a specific agency (or route or stop)
	isZoomedOutOnLoad: () => {
		const params = new URLSearchParams( location.search );
		if ( params.get( "tab" ) && params.get( "tab" ) !== 'bus_routes' ) return true;
		if ( !params.get( "agency" ) ) return true;
		return false;
	},

	isDesktop: () => {
		// todo don't hardcode breakpoint
		return window.innerWidth >= 1280;
	},

	shouldDisplayZoomControls: async ( tm ) => {
		tm.map.setOptions( {
			zoomControl: Utilities.isDesktop()
		} );
	},

	// zoom to specified bounds, allowing whitespace on the left for the sidebar
	zoomToBounds: ( tm, bounds, updateCurrentBounds = true ) => {
		// sometimes if you zoom in too far at once, the stroke widths don't rescale, so they're huge and blurry until you manually rezoom
		// this is an attempt to prevent that
		// note: working without an api key seems less likely to trigger this bug, so test with the api key enabled
		google.maps.event.addListenerOnce( tm.map, 'zoom_changed', () => {
			const targetZoom = tm.map.getZoom();
			if ( targetZoom >= currentZoom + 4 ) {
				tm.map.setZoom( targetZoom - 1 );
				setTimeout( function () {
					tm.map.setZoom( targetZoom );
				}, 15 ); // 1ms doesn't work reliably (e.g. when switching away from Trip Planner tab)
			}
		} );

		if ( updateCurrentBounds ) tm.currentBounds = bounds;

		const currentZoom = tm.map.getZoom(),
			left = Utilities.isDesktop() ? 473 : 0, // the width of the sidebar; map should not place features underneath it
			padding = {top: 60, right: 20, bottom: 60, left: left + 20};// top/bottom have a little extra to balance markers

		tm.map.fitBounds( bounds, padding );

		return true;
	},

	// helper function for 'tm__change-tab' event
	getMissingTabsOrIndices: ( tm, detail, tabs = null ) => {
		tabs = tabs ? tabs : tm.$sidebar.querySelector( 'ul' ).querySelectorAll( 'a' );

		// get the new/old tabs/indices, assuming two were passed and two are missing
		let newTab = detail.newTab,
			oldTab = detail.oldTab,
			newIndex = detail.newIndex,
			oldIndex = detail.oldIndex;

		if ( !newTab || !oldTab ) {
			newTab = [...tabs].find( elem => elem.id === 'tab' + newIndex );
			oldTab = [...tabs].find( elem => elem.id === 'tab' + oldIndex );
		} else
			if ( typeof newIndex === 'undefined' && typeof oldIndex === 'undefined' ) {
				newIndex = [...tabs].findIndex( elem => elem === newTab );
				oldIndex = [...tabs].findIndex( elem => elem === oldTab );
			}
		return [newTab, oldTab, newIndex, oldIndex];
	},

	getStrokeColor: ( itemId ) => {
		let color = (typeof tmColors !== 'undefined') ? tmColors[itemId] : false;
		return (color && /^#[0-9A-F]{6}$/i.test( color )) ? color : '#000000';
	},

	getMarkerColor: ( itemId, amount = - 50 ) => {
		// modified from https://stackoverflow.com/a/57401891/11420510
		let color = Utilities.getStrokeColor( itemId );
		return '#' + color.replace( /^#/, '' ).replace( /../g, color => ('0' + Math.min( 255, Math.max( 0, parseInt( color, 16 ) + amount ) ).toString( 16 )).slice( - 2 ) );
	},

	escapeHtml: ( string ) => {
		// https://stackoverflow.com/a/12034334
		let entityMap = {
			'&': '&amp;',
			'<': '&lt;',
			'>': '&gt;',
			'"': '&quot;',
			"'": '&#39;',
			'/': '&#x2F;',
			'`': '&#x60;',
			'=': '&#x3D;'
		};

		return String( string ).replace( /[&<>"'`=\/]/g, ( s ) => {
			return entityMap[s];
		} );
	},

	deepEqual: ( obj1, obj2 ) => {
		// If the objects are strictly equal, they are the same
		if ( obj1 === obj2 ) {
			return true;
		}

		// Check if both objects are objects and not null
		if ( typeof obj1 !== 'object' || obj1 === null || typeof obj2 !== 'object' || obj2 === null ) {
			return false;
		}

		// Get the keys of both objects
		const keys1 = Object.keys( obj1 );
		const keys2 = Object.keys( obj2 );

		// If the number of keys is different, objects are not the same
		if ( keys1.length !== keys2.length ) {
			return false;
		}

		// Recursively compare each key-value pair
		for ( let key of keys1 ) {
			if ( !keys2.includes( key ) || !Utilities.deepEqual( obj1[key], obj2[key] ) ) {
				return false;
			}
		}

		// All checks pass, objects are the same
		return true;
	},

	throttle: ( fn, delay ) => {
		let timeout = null;
		return function ( ...args ) {
			if ( !timeout ) {
				timeout = setTimeout( () => {
					timeout = null;
					fn.apply( this, args );
				}, delay );
			}
		};
	},

	// modified from https://www.sitepoint.com/cache-fetched-ajax-requests/
	// TODO: request compressed files
	cachedFetch: ( url, options ) => {
		const cacheKey = url,
			cached = localStorage.getItem( cacheKey ),
			cacheVersion = localStorage.getItem( cacheKey + ':v' ),
			currentVersion = tmVars.version;

		if ( cached !== null && cacheVersion !== null ) {
			if ( currentVersion === cacheVersion ) {
				// cached version is current; return the cached value
				const response = new Response( new Blob( [cached] ) )
				return Promise.resolve( response )
			} else {
				// cached value is for a past version, clear it
				localStorage.removeItem( cacheKey )
				localStorage.removeItem( cacheKey + ':v' )
			}
		}

		// localStorage is either out of date or not set; do not use a cached value if one exists
		options = {
			...options,
			cache: 'no-store'
		};

		return fetch( url, options ).then( response => {
			if ( response.status === 200 ) {
				const ct = response.headers.get( 'Content-Type' )
				// only cache text and (geo)json responses
				if ( ct && (ct.match( /application\/json/i ) || ct.match( /application\/geo\+json/i ) || ct.match( /text\//i )) ) {
					// If we don't clone the response, it will be consumed by the time it's returned. This way we're being un-intrusive.
					response.clone().text().then( content => {
						localStorage.setItem( cacheKey, content )
						localStorage.setItem( cacheKey + ':v', currentVersion )
					} )
				}
			}
			return response
		} )
	}
}

export default Utilities;
